module.exports = __webpack_public_path__ + "img/weixin-sxymba.636879c6.png";